import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { UserCircleIcon } from "@heroicons/react/outline";

import { classNames } from "helpers";
import { useAuth } from "GlobalProvider";

export const ProfileDropdown = () => {
  const { logoutUser } = useAuth();

  return (
    <Menu as="div" className="relative">
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <Menu.Item>
            {({ active }) => (
              <button
                className={classNames(
                  active ? "bg-gray-100" : "",
                  "block px-4 py-2 text-sm text-gray-700 w-full"
                )}
                onClick={logoutUser}
              >
                Sing out
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
      <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
        <Menu.Button className="flex-shrink-0 w-full group block">
          <div className="flex items-center text-gray-700 group-hover:text-gray-900">
            <div>
              <UserCircleIcon className="inline-block h-9 w-9 rounded-full" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">Anita Hucic</p>
            </div>
          </div>
        </Menu.Button>
      </div>
    </Menu>
  );
};
